// Module
var code = `<div class="page-item--stats-band">
  {{#items}}
  <div class="stat">
    <div class="stat-value">{{value}}</div>
    <div class="stat-label">{{label}}</div>
  </div>
  {{/items}}
</div>
`;
// Exports
module.exports = code;